const isLocalhost = window.location.host == "localhost:5000";
export const apiUrl = isLocalhost
  ? "http://localhost:2325"
  : "https://api.rbhidraulicos.com.br";
